import useAuthStore from './auth';
import useChatStore from './chat';
import useCommonStore from './common';
import useCompanyStore from './company';
import useFeedsStore from './feeds';
import useResumeStore from './resume';
import useSocketStore from './socket';
import useUserStore from './user';
import useZegoCloudStore from './zegoCloud';
import useuseFeedsForYouStore from './feedsForYou';
import useFeedsFollowingStore from './feedsFollowing';

export const resetAllStores = () => {
	useAuthStore.getState().resetState();
	useChatStore.getState().resetState();
	useCommonStore.getState().resetState();
	useCompanyStore.getState().resetState();
	useFeedsStore.getState().resetFeeds();
	useResumeStore.getState().resetState();
	useSocketStore.getState().resetState();
	useUserStore.getState().resetState();
	useZegoCloudStore.getState().resetState();
	useuseFeedsForYouStore.getState().resetFeeds();
	useFeedsFollowingStore.getState().resetFeeds();
};
